<b-col lg="4" md="6" sm="12">
    <b-card class="algorithm-component">
        <img :src="require('../assets/algorithms/' + algName + '.png')" />
        <p>{{ algName.toUpperCase() }}</p>
        <a :href="stepsLink">{{ steps.replace(/\./g, '') }}</a>
    </b-card>
</b-col>
